import { AxiosError } from 'axios'

export const AI_FILL_UNAVAILABLE_MESSAGE = 'AI service unavailable'
export const AI_FILL_FAILED_MESSAGE = 'Failed to generate suggestions'

/** Map axios/network failures to user-facing AI fill toast messages. */
export function getAmmoAiFillErrorMessage (error: unknown): string {
  if (!error || typeof error !== 'object') {
    return AI_FILL_UNAVAILABLE_MESSAGE
  }

  const axiosError = error as AxiosError
  if (!axiosError.response) {
    return AI_FILL_UNAVAILABLE_MESSAGE
  }

  const status = axiosError.response.status
  const apiError =
    axiosError.response.data &&
    typeof axiosError.response.data === 'object' &&
    'error' in axiosError.response.data &&
    typeof (axiosError.response.data as { error?: unknown }).error === 'string'
      ? (axiosError.response.data as { error: string }).error
      : null

  if (status === 502 || status === 503) {
    return apiError ?? AI_FILL_UNAVAILABLE_MESSAGE
  }

  return AI_FILL_FAILED_MESSAGE
}
